import { markInputRule } from '@tiptap/core';
import Bold from '@tiptap/extension-bold';
import { starPasteRegex } from '@tiptap/extension-italic';

const CustomBold = Bold.extend({
  renderHTML() {
    return ['b', 0];
  },

  // Add this to reset input rules and only use starPasteRegex
  addInputRules() {
    return [
      markInputRule({
        find: starPasteRegex,
        type: this.type,
      }),
    ];
  },
});

export default CustomBold;
